import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";

type UploadResourceRequestResponse = {
    url: string;
};

export const uploadResourceRequest = async (
    base64Data: string,
    fileType: string,
    fileName: string,
    workflowId: string,
    serviceId: string,
    category: string
): Promise<{ data: UploadResourceRequestResponse; error: any }> => {
    const body = {
        category: category,
        file: base64Data,
        fileName: fileName,
        fileType: fileType,
        workflowID: workflowId,
        serviceID: serviceId
    };
    const route = apiRoutes.serviceConfiguration.resource.upload;
    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route,  body);
    return { data, error };
};